import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const Cms = () => (
  <>
     <Paragraph>
        Having experimented on Wordpress, Joomla, Prestashop (a Smarty/php-based
        e-commerce platform) and few in-house CMS, I am confident that I am able
        to adapt to any internal <Accent>Content Management System</Accent>.
    </Paragraph>
  </>
);

Cms.propTypes = {};

export default Cms;
